import { CompanyRole } from "interfaces";
import { components } from "../types/openapi";

export type BidRequestStatus = components["schemas"]["RequestGridDto"]["status"];
export type ContractStatus = components["schemas"]["ContractCardDto"]["status"];
export type CompanyStatus = components["schemas"]["CompanyDto"]["status"];
export type QuoteStatus = components["schemas"]["QuoteViewDto"]["status"];
export type StatusHistoryType = components["schemas"]["RequestHistoryDto"];
export type RequestProcessingHistoryType = components["schemas"]["RequestProcessingHistoryDefaultDto"];

export const BID_REQUEST_STATUS_ENUM: Record<BidRequestStatus, BidRequestStatus> = {
  DRAFT: "DRAFT",
  DRAFT_DECLINED: "DRAFT_DECLINED",
  DRAFT_APPROVED: "DRAFT_APPROVED",
  AGENT_PROPOSAL: "AGENT_PROPOSAL",
  AGENT_PROPOSAL_ACCEPTED: "AGENT_PROPOSAL_ACCEPTED",
  NEW: "NEW",
  EXPIRED: "EXPIRED",
  QUOTE_PROPOSED: "QUOTE_PROPOSED",
  FUNDING: "FUNDING",
  AML_FAILED: "AML_FAILED",
  AML_CHECK: "AML_CHECK",
  AML_FAILED_REFUNDING: "AML_FAILED_REFUNDING",
  AML_FAILED_REFUNDED: "AML_FAILED_REFUNDED",
  FUNDED: "FUNDED",
  EXECUTION: "EXECUTION",
  COMPLETED: "COMPLETED",
  CANCELED_REFUNDING: "CANCELED_REFUNDING",
  CANCELED_REFUNDED: "CANCELED_REFUNDED",
  CANCELED: "CANCELED",
};

//проставить index и по ней опр

export const BID_STEP_STATUSES = [
  {
    title: "Создание заявки",
    statuses: [
      BID_REQUEST_STATUS_ENUM.DRAFT,
      BID_REQUEST_STATUS_ENUM.DRAFT_APPROVED,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL,
      BID_REQUEST_STATUS_ENUM.AGENT_PROPOSAL_ACCEPTED,
    ],
  },
  {
    title: "Оплата",
    statuses: [
      BID_REQUEST_STATUS_ENUM.NEW,
      BID_REQUEST_STATUS_ENUM.QUOTE_PROPOSED,
      BID_REQUEST_STATUS_ENUM.EXPIRED,
      BID_REQUEST_STATUS_ENUM.FUNDING,
      BID_REQUEST_STATUS_ENUM.AML_CHECK,
      BID_REQUEST_STATUS_ENUM.AML_FAILED,
      BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDED,
      BID_REQUEST_STATUS_ENUM.AML_FAILED_REFUNDING,
      BID_REQUEST_STATUS_ENUM.FUNDED,
    ],
  },
  {
    title: "Исполнение",
    statuses: [
      BID_REQUEST_STATUS_ENUM.EXECUTION,
      BID_REQUEST_STATUS_ENUM.COMPLETED,
      BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDED,
      BID_REQUEST_STATUS_ENUM.CANCELED_REFUNDING,
      BID_REQUEST_STATUS_ENUM.CANCELED,
    ],
  },
] as const;

export const BID_STEP_STATUS_TITLE = {
  DRAFT: "Черновик",
  DRAFT_DECLINED: "Черновик отклонен",
  DRAFT_APPROVED: "Заявка одобрена",
  AGENT_PROPOSAL: "Согласование агентских условий",
  AGENT_PROPOSAL_ACCEPTED: "Агентские условия согласованы",
  NEW: "Сбор котировок",
  EXPIRED: "Предложение истекло",
  QUOTE_PROPOSED: "Котировка предложена",
  FUNDING: "Обеспечение средствами",
  FUNDED: "Готова к исполнению",
  EXECUTION: "Исполнение",
  COMPLETED: "Исполнена",
  AML_FAILED: "Согласование транзакции",
  CANCELED: "Отменена",
  AML_CHECK: "Проверка AML",

  CANCELED_REFUNDING: "Отменена, возврат ЦВ",
  AML_FAILED_REFUNDING: "Транзакция не согласована, возврат криптовалюты",
  CANCELED_REFUNDED: "Отменена, ЦВ возвращена",
  AML_FAILED_REFUNDED: "Отклонена, ЦВ возвращена",
};

export const BID_STATUSES: TCommonStatus<BidRequestStatus> = {
  texts: {
    DRAFT: "Черновик",
    DRAFT_DECLINED: "Черновик отклонен",
    DRAFT_APPROVED: "Заявка согласована",

    AGENT_PROPOSAL: "Согласование агентских условий",
    AGENT_PROPOSAL_ACCEPTED: "Агентские условия согласованы",
    NEW: "Сбор котировок",
    EXPIRED: "Предложение истекло",
    QUOTE_PROPOSED: "Котировка предложена",
    FUNDING: "Обеспечение средствами",
    FUNDED: "Готова к исполнению",
    EXECUTION: "Исполнение",
    COMPLETED: "Исполнена",
    AML_FAILED: "Согласование транзакции",
    CANCELED: "Отменена",
    AML_CHECK: "Проверка AML",
    CANCELED_REFUNDING: "Отменена, возврат ЦВ",
    AML_FAILED_REFUNDING: "Транзакция не согласована, возврат криптовалюты",
    CANCELED_REFUNDED: "Отменена, ЦВ возвращена",
    AML_FAILED_REFUNDED: "Отклонена, ЦВ возвращена",
  },
  colors: {
    DRAFT: "gray",
    DRAFT_APPROVED: "gray",
    AGENT_PROPOSAL: "purple",
    AGENT_PROPOSAL_ACCEPTED: "green",
    NEW: "purple",
    QUOTE_PROPOSED: "green",
    EXPIRED: "gray",
    FUNDING: "green",
    FUNDED: "purple",
    EXECUTION: "gray",
    COMPLETED: "green",
    AML_FAILED: "gray",
    CANCELED: "gray",
    AML_CHECK: "purple",
    CANCELED_REFUNDING: "gray",
    AML_FAILED_REFUNDING: "gray",
    CANCELED_REFUNDED: "gray",
    AML_FAILED_REFUNDED: "gray",
    DRAFT_DECLINED: "red",
  },
};

export const CONTRACT_STATUS_ENUM: Record<ContractStatus, ContractStatus> = {
  DRAFT: "DRAFT",
  DRAFT_DECLINED: "DRAFT_DECLINED",
  PAID: "PAID",
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
};

export const CONTRACT_STATUSES: TCommonStatus<ContractStatus> = {
  texts: {
    DRAFT: "Черновик",
    PAID: "Оплачен",
    ACTIVE: "Активный",
    DRAFT_DECLINED: "Черновик отклонен",
    BLOCKED: "Заблокирован",
  },
  colors: {
    DRAFT: "blue",
    DRAFT_DECLINED: "red",
    PAID: "gray",
    ACTIVE: "green",
    BLOCKED: "red",
  },
  index: {
    DRAFT: 0,
    PAID: 2,
    ACTIVE: 1,
    BLOCKED: 3,
    DRAFT_DECLINED: 4,
  },
};

export const CONTRACT_STATUS_FILTERS_PENDING_PAGE_TEXTS = [
  CONTRACT_STATUS_ENUM.DRAFT,
  CONTRACT_STATUS_ENUM.DRAFT_DECLINED,
].map((status) => CONTRACT_STATUSES.texts[status]);

export const COMPANY_STATUS_ENUM: Record<CompanyStatus, CompanyStatus> = {
  DRAFT: "DRAFT",
  ACTIVE: "ACTIVE",
  BLOCKED: "BLOCKED",
  ARCHIVED: "ARCHIVED",
};

export const COMPANY_STATUSES: TCommonStatus<CompanyStatus> = {
  texts: {
    DRAFT: "Черновик",
    ACTIVE: "Активный",
    BLOCKED: "Приостановлен",
    ARCHIVED: "Архив",
  },
  colors: {
    DRAFT: "blue",
    ACTIVE: "green",
    ARCHIVED: "gray",
    BLOCKED: "red",
  },
};

export const isCompanyActive = (status: CompanyStatus): boolean => {
  return ![COMPANY_STATUS_ENUM.BLOCKED, COMPANY_STATUS_ENUM.ARCHIVED].includes(status);
};

export const QUOTE_STATUS_ENUM: Record<QuoteStatus, QuoteStatus> = {
  CREATED: "CREATED",
  OFFERED: "OFFERED",
  ACCEPTED: "ACCEPTED",
  EXPIRED: "EXPIRED",
  CANCELED: "CANCELED",
};

export const QUOTE_STATUSES: TCommonStatus<QuoteStatus> = {
  texts: {
    CREATED: "Новая котировка",
    OFFERED: "Предложено УВЭД",
    ACCEPTED: "Принято УВЭД",
    EXPIRED: "Истекла",
    CANCELED: "Отменена",
  },
  colors: {
    CREATED: "blue",
    OFFERED: "orange",
    ACCEPTED: "green",
    EXPIRED: "gray",
    CANCELED: "gray",
  },
};

export type WithdrawalRequestStatus = "CREATED" | "PROCESSING" | "COMPLETED" | "CANCELLED";
export const WithdrawalRequestStatusList = ["CREATED", "PROCESSING", "COMPLETED", "CANCELLED"];

export const WITHDRAWAL_REQUEST_STATUSES: TCommonStatus<WithdrawalRequestStatus> = {
  texts: {
    CREATED: "Создана",
    PROCESSING: "В работе",
    COMPLETED: "Исполнена",
    CANCELLED: "Отменена",
  },
  colors: {
    CREATED: "purple",
    PROCESSING: "gray",
    COMPLETED: "green",
    CANCELLED: "gray",
  },
};

export enum WITHDRAWAL_REQUEST_STATUSES_ENUM {
  CREATED = "CREATED",
  PROCESSING = "PROCESSING",
  COMPLETED = "COMPLETED",
  CANCELLED = "CANCELLED",
}

export type TCommonStatus<T extends keyof any> = {
  texts: Record<T, string>;
  colors: Record<T, string>;
  index?: Record<T, number>;
};

export const getEnumKeys = <T extends Record<string, any>>(obj: T): Array<keyof T> => {
  return Object.keys(obj) as Array<keyof T>;
};

export enum QUOTE_SELECTION_ENUM {
  CUSTOMER = "CUSTOMER",
  OPERATOR = "OPERATOR",
}

export enum SUB_STEP_STATUSES_ENUM {
  FIAT_SENT = "FIAT_SENT",
  FIAT_RECEIVED = "FIAT_RECEIVED",
  TOKEN_RECEIVED = "TOKEN_RECEIVED",
  NATIVE_RECEIVED = "NATIVE_RECEIVED",
  RUB_RECEIVED_BY_PLATFORM = "RUB_RECEIVED_BY_PLATFORM",
  FEE_RUB_RECEIVED_BY_PLATFORM = "FEE_RUB_RECEIVED_BY_PLATFORM",
  FIAT_WITHDRAWAL_REQUESTED = "FIAT_WITHDRAWAL_REQUESTED",
  CUSTOMER_EXECUTED = "CUSTOMER_EXECUTED",
  CREATE_QUOTE = "CREATE_QUOTE",
  VERIFY_WALLET_QUOTE = "VERIFY_WALLET_QUOTE",
  VERIFY_WALLET_REQUEST = "VERIFY_WALLET_REQUEST",
}

export enum CONTRACT_DIRECTION_ENUM {
  EXP = "EXP",
  IMP = "IMP",
}
